import get from 'lodash.get';
import { MoveTimeCriteriaType } from '~/types';
import { useMeContext } from '~/modules/me/useMeContext';

const useAvailableCriteria = () => {
  const { groupSettings, permissionsMap } = useMeContext();

  const locationSettings = get(groupSettings, 'location', {});
  const departmentSettings = get(groupSettings, 'department', {});
  const employeeTypeSettings = get(groupSettings, 'employeeType', {});
  const costCenterSettings = get(groupSettings, 'costCenter', {});
  const serviceCenterSettings = get(groupSettings, 'serviceCenter', {});
  const divisionSettings = get(groupSettings, 'division', {});

  const canViewLocation = Boolean(
    permissionsMap['urn:replicon:project-action:view-location']
  );

  const canViewDepartment = Boolean(
    permissionsMap['urn:replicon:project-action:view-department']
  );

  const canViewEmployeeType = Boolean(
    permissionsMap['urn:replicon:project-action:view-employee-type']
  );

  const canViewCostCenter = Boolean(
    permissionsMap['urn:replicon:project-action:view-cost-center']
  );

  const canViewServiceCenter = Boolean(
    permissionsMap['urn:replicon:project-action:view-service-center']
  );

  const canViewDivision = Boolean(
    permissionsMap['urn:replicon:project-action:view-division']
  );

  const availableCriteria = [];

  if (canViewCostCenter && costCenterSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.CostCenter,
      labelId: 'moveTimeDialog.criteria.costCenter'
    });
  }

  availableCriteria.push({
    type: MoveTimeCriteriaType.DateRange,
    labelId: 'moveTimeDialog.criteria.dateRange'
  });

  if (canViewDepartment && departmentSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.Department,
      labelId: 'moveTimeDialog.criteria.department'
    });
  }

  if (canViewDivision && divisionSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.Division,
      labelId: 'moveTimeDialog.criteria.division'
    });
  }

  if (canViewEmployeeType && employeeTypeSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.EmployeeType,
      labelId: 'moveTimeDialog.criteria.employeeType'
    });
  }

  if (canViewLocation && locationSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.Location,
      labelId: 'moveTimeDialog.criteria.location'
    });
  }

  if (canViewServiceCenter && serviceCenterSettings.isEnabled) {
    availableCriteria.push({
      type: MoveTimeCriteriaType.ServiceCenter,
      labelId: 'moveTimeDialog.criteria.serviceCenter'
    });
  }

  availableCriteria.push({
    type: MoveTimeCriteriaType.User,
    labelId: 'moveTimeDialog.criteria.user'
  });

  return availableCriteria;
};

export default useAvailableCriteria;
